import React, { useEffect, useState } from 'react';
import MostrarFelicidades from '../componentes/MostrarFelicidades';
import { socket } from '../socket';

const Felicidades = () => {

    const [nombre, setNombre] = useState('');
    const [club, setClub] = useState('');
    const [aparato, setAparato] = useState('');

    useEffect(() => {
        socket.on('felicidades-data', data => {
            console.log("Felicidades data received:", data);
            setNombre(data.nombre);
            setClub(data.club);
            setAparato(data.aparato);
        });
    }, []);

    return (
        <div>
            <MostrarFelicidades aparato={aparato} nombre={nombre} club={club}/>
        </div>
    );
};

export default Felicidades;
